export * from './lib/menu-feature-shell.module';
